import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import Help from '../../generics/help';

var Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');
const style = {
  margin: 7,
};

class RemoveReserve extends Component{
	constructor(props){
		super(props);

		this.getList = this.getList.bind(this);
		this.onCheck = this.onCheck.bind(this);
		this.saveItem = this.saveItem.bind(this);
		this.cancel = this.cancel.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.saveAutologa = this.saveAutologa.bind(this);
		this.saveReserved = this.saveReserved.bind(this);

		this.state = {
			list:[],
			filterText:"",
			columns:[],
		}
	}

	componentDidMount(){
		this.getList();

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=REMOVE_RESERVE',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => response.json())
      	.then(response => {
        	if(response !== undefined){
          		this.setState({ columns: response });
        	}
      	})
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value})
	}

	getList(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'units/reserved?health_facilities_id='+
			sessionStorage.getItem('health_facilities_id'), {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res =>{
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				response.map((res)=>{
					res.check = false;
				})
				this.setState({list:response})
			}
		});
	}

	onCheck(e){
		var check = e.target.checked;
		var id = parseInt(e.target.id.split('_')[1]);

		this.state.list.map((l, i)=>{
			if(e.target.id === 'all'){
				l.check = check ? true : false;
			}else if(id === i){
				l.check = check ? true : false;
			} 
		})
		this.forceUpdate();
	}

	saveItem(e){
		e.preventDefault();

		var units = [];
		var unit_autologa = [];

		this.state.list.map((l)=>{
			if(l.check){
				if(l.reserved_id === 0){
					unit_autologa.push(l.id);
				}else{
					units.push(l.reserved_id);
				}
				
			}
		});

		if(units.length + unit_autologa.length > 0){
			if(units.length > 0 ){
				this.props.waiting.handleShow('Retirando...');
				this.saveReserved(units);
			}

			if(unit_autologa.length > 0){
				this.props.waiting.handleShow('Retirando...');
				this.saveAutologa(unit_autologa);
			}

		}else{
			swal('Error', 'Debe seleccionar al menos una unidad', 'error');
		}
	}

	saveReserved(units){
		fetch(Config.default.apiGateway.URL+'units/remove_reserved', {
			method:'post',
			body:JSON.stringify(units),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				swal('Bien Hecho', 'Retiro de reserva correcto', 'success');
				this.getList();
			}
		})
	}

	saveAutologa(units){
		fetch(Config.default.apiGateway.URL+'units/remove_reserved_autologa', {
			method:'post',
			body:JSON.stringify(units),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				swal('Bien Hecho', 'Retiro de reserva correcto', 'success');
				this.getList();
			}
		})
	}

	cancel(e){
		e.preventDefault();
		this.props.history.push('/');
	}

	filter(row){
		
		var res = true;
		
		if(row !== null){
			
			var str = row.petition_id+' '+row.unit_number+' '+row.patient+' '+row.component+' '+
					row.component_number+' '+row.volume+' '+moment(row.caducidad).format('DD/MM/YYYY HH:mm')+' '+row.group+
					' '+(row.rh === 'POSITIVO' ? '+' : row.rh === 'NEGATIVO' ? '-' : '');
			
			
			if(str.indexOf(this.state.filterText.toLocaleUpperCase()) !== -1){
				res = true;
			}else{
				res = false;
			}
		}

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Retirar Reserva
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_remove_reserve"}  />
	                
				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Filtro</span>
						<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
							value={this.state.filterText} onChange={this.handleChange} />
					</div>
				</div>

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th>
									{/*<input type="checkbox" id={'all'} onChange={this.onCheck} />*/}
								</th>
								<th hidden={this.showColumn('PETITION_NUMBER')}>No. Petición</th>
								<th hidden={this.showColumn('UNIT_NUMBER')}>No. Unidad</th>
								<th hidden={this.showColumn('PATIENT')}>Paciente</th>
								<th hidden={this.showColumn('COMPONENT')}>Componente</th>
								<th hidden={this.showColumn('COMPONENT_NUMBER')}>No. Componente</th>
								<th hidden={this.showColumn('VOLUME')}>Volumen</th>
								<th hidden={this.showColumn('EXPIRED_DATE')}>Caducidad</th>
								<th hidden={this.showColumn('GROUP_RH')}>Grupo & RH</th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((l,i)=>(
								this.filter(l) ?
									<tr key={i}>
										<td>
											<input type="checkbox" id={'unit_'+i} 
												checked={l.check} onChange={this.onCheck} />
										</td>
										<td hidden={this.showColumn('PETITION_NUMBER')}>{l.petition_id}</td>
										<td hidden={this.showColumn('UNIT_NUMBER')}>{l.unit_number}</td>
										<td hidden={this.showColumn('PATIENT')}>{l.patient}</td>
										<td hidden={this.showColumn('COMPONENT')}>{l.component}</td>
										<td hidden={this.showColumn('COMPONENT_NUMBER')}>{l.component_number}</td>
										<td hidden={this.showColumn('VOLUME')}>{l.volume + ' ml'}</td>
										<td hidden={this.showColumn('EXPIRED_DATE')}>{moment(l.caducidad).format('DD/MM/YYYY HH:mm')}</td>
										<td hidden={this.showColumn('GROUP_RH')}>
											{l.group+' '}
											{l.rh === 'POSITIVO' ? '+' : l.rh === 'NEGATIVO' ? '-' : ''}
										</td>
									</tr>
								: null
							))}
						</tbody>
					</Table>
				</div>

				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<RaisedButton className="action-btn" label="RETIRAR" primary={true} onClick={this.saveItem} style={style}/>
	        		<RaisedButton className="action-btn" label="REGRESAR" primary={true} onClick={this.cancel} style={style}/>
		        </div>
			</div>
		)
	}

}

export default translate('translations')(RemoveReserve);